import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_CLIENT_LEVEL, STR_COMPANY, STR_CONTACT_US, STR_COULD_NOT_FETCH_DATA, STR_CUSTOMER, STR_EMAIL_ADDRESS, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_INVALID_NAME, STR_INVALID_NAME_2, STR_INVALID_PHONE_2, STR_LEAD, STR_NAME, STR_OPTIONAL, STR_PHONE_NUMBER, STR_PHYSICAL_ADDRESS, STR_POBOX, STR_REGISTER_BUSINESS, STR_REGISTER_CLIENT, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_TIN, STR_VRN, STR_WEBSITE_URL, STR_WHATSAPP_NUMBER, STR_WITH_COUNTRY_CODE } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";
import NapaAddressPicker from "../ones/NapaAddressPicker";


export default function ContactUs({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState(null);
	

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
		])
		setReady(true);
	}

	async function getData() {
		await callApi('get-client-data', { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
  }
	
	useEffect(() => {
		init();
	}, [uuid])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && data) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title">
								{data.name}
							</h6>
						</div>

					

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}